import { render, staticRenderFns } from "./menuTree.vue?vue&type=template&id=bf2efc46&"
import script from "./menuTree.vue?vue&type=script&lang=js&"
export * from "./menuTree.vue?vue&type=script&lang=js&"
import style0 from "./menuTree.vue?vue&type=style&index=0&id=bf2efc46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports